import {delegate, padNumber, getShareLayers, createShareImage, convertName} from "./_utilities";
import {ACTIONS} from "./_actions";
import {store, store$} from "./_config-store";
import {getExteriorBuilder} from "./_exterior-builder";
import {rotateTruck} from "./_exterior-methods";


export default function intents($container) {
	function normalizeGestureData(e) {
		let touch = e.event.originalEvent.touches;
		return touch ? touch[0].pageX : e.event.pageX;
	}

	let mobile = new MobileDetect(window.navigator.userAgent);
	let isMobile = mobile.mobile() || mobile.tablet();

	let mouseleave = delegate($container, ".layers", 'mouseleave');

	let uiEvent$ = store$
		.filter(state => state.dataReady)
		.filter(state => state.actionType !== ACTIONS.INTERIOR_BUILD_CHANGE)
		.filter(state => state.actionType !== ACTIONS.QUOTE_DISABLED);


	let activeSummaryChange$ = uiEvent$
		.filter(state => state.actionType === ACTIONS.ACTIVE_SUMMARY_CHANGE)
		.map(state => ACTIONS.ACTIVE_SUMMARY_CHANGE);

	let viewOptionChange$ = uiEvent$
		.filter(state => state.actionType === ACTIONS.VIEW_OPTION_CHANGE);

	let gestureStart$ = delegate($container, ".layers", "mousedown touchstart")
		.map(normalizeGestureData);
	let gestureMove$ = delegate($container, ".layers", "mousemove touchmove")
		.map(normalizeGestureData)
		.pairwise();
	let gestureEnd$ = delegate($container, ".layers", "mouseup touchend");

	/**
	 * truck rotation intent
	 */
	let rotateTruckDrag$ = gestureStart$
		.flatMap(startX => {
			return gestureMove$
				.map(([prevX, currX]) => {
					return {
						startX,
						prevX,
						currX
					};
				})
				.takeUntil(Rx.Observable.merge(gestureEnd$, mouseleave));
		})
		.scan((acc, data) => {
			// console.log(acc, action)
			// check for direction
			// if changed reset starting point for computing progress
			let startX = acc.startX || data.startX;
			let currX = data.currX;
			let prevX = data.prevX;
			let direction = acc.direction;
			let currentDirection = currX - prevX > 0 ? -1 : 1;
			let movement = true;
			if (direction !== currentDirection) {
				startX = currX;
				direction = currentDirection;
			}
			if (Math.abs(currX - startX) > 30) {
				startX = currX;
			} else {
				movement = false;
			}
			return {
				startX,
				direction,
				movement
			}
		}, {
			startX: false,
			direction: 0,
		})
		.filter(({movement}) => movement)
		.filter(() => {
			// prevent rotating the truck during the initial render
			return $container.find(".progress-bar-mask:visible").length === 0;
		})
		.mergeMap(({direction}) => rotateTruck(direction, getExteriorBuilder().store.getState()));

	let keyControl$ = Rx.Observable.fromEvent(document, "keydown");
	let rotateTruckKey$ = keyControl$
		.filter(e => {
			return e.keyCode === 37 || e.keyCode === 39;
		})
		.filter(() => {
			return store.getState().view === "exterior";
		})
		.filter(() => {
			// prevent rotating the truck during the initial render
			return $container.find(".progress-bar-mask:visible").not(".remainder").length === 0;
		})
		.mergeMap(e => rotateTruck(38 - e.keyCode, getExteriorBuilder().store.getState()));

	let targetRotation$ = keyControl$
		.do(e => console.log("key", e))
		.filter(e => e.key === "r")
		.switchMap(e => rotateTruck(1, getExteriorBuilder().store.getState(), 180));

	/**
	 * used to export truck images for use in the sales tool
	 * NOT needed for production
	 */
	// if (process.env.NODE_ENV !== `production`) {
	// 	const download = require("downloadjs");
	// 	const JSZip = require("jszip");
	// 	console.group("Truck Export Commands");
	// 	console.log(`%c
	// 	***********************************
	// 	*     Truck Export Commands       *
	// 	*                                 *
	// 	*  only available in development  *
	// 	*                                 *
	// 	***********************************
		
	// 	1. Ctrl-Alt-Cmd-S to save 12 frames of the truck:
	// 	   This will be every other frame starting from pointing left
	// 	2. Ctrl-Alt-Cmd-A to save x frames of the truck:
	// 	   You will be prompted for the divisor
	// 	3. Ctrl-Alt-Cmd-D to add a color to choose from:
	// 	   You will be prompted for name and hex color
		
	// 	`, "font-family: monospace");
	// 	console.groupEnd();
	// 	let captureTruckImages$ = keyControl$
	// 		.filter(() => process.env.NODE_ENV !== `production`)
	// 		.filter(e => {
	// 			console.log(e.keyCode)
	// 			return (e.keyCode === 83 || e.keyCode === 65)
	// 			&& e.altKey === true
	// 			&& e.metaKey === true
	// 			&& e.ctrlKey === true
	// 		})
	// 		.do(() => console.log("we are capturing with key command"))
	// 		.switchMap(e => {
	// 			let indices = isMobile ? _.range(0, 7, 1) : _.range(0, 23, 2);
	// 			if (e.keyCode === 65) {
	// 				let options = [1, 2, 3, 4, 6, 8, 12, 24];
	// 				let div = prompt(`Enter frame number divisor from: ${options}`);
	// 				let divInt = parseInt(div, 10);
	// 				let divisorValid = divInt && _.includes(options, divInt);
	// 				if(divisorValid) {
	// 					indices = _.range(0, 23, divInt);
	// 				}
	// 			}
	// 			// else {
	// 			// 	indices = _.range(0, 24, 1);
	// 			// }
	// 			return Rx.Observable.from(indices)
	// 				.concatMap(index => {
	// 					return getShareLayers($("#exterior-builder [data-layer]:not(.hidden)"), index);
	// 				})
	// 				.concatMap(imageData => createShareImage(imageData, "png"))
	// 				.bufferCount(indices.length)
	// 		})
	// 		.concatMap(images => {
	// 			// console.log(`downloading image number ${i} with key command`);
	// 			// download(`data:image/jpeg;base64,${img}`, `${convertName(store.getState().truckCab)}-${padNumber(i, 2)}.jpg`, "image/jpg");
	// 			let zip = new JSZip();
	// 			images.forEach((img, i) => {
	// 				zip.file(
	// 					`${convertName(store.getState().truckCab)}-${padNumber(i, 2)}.png`,
	// 					`${img}`,
	// 					{
	// 						base64: true
	// 					}
	// 				);
	// 			});
	// 			zip.generateAsync({type: "blob"})
	// 				.then(content => {
	// 					// saveAs(content, `${convertName(store.getState().truckCab)}-images.zip`)
	// 					download(content, `${convertName(store.getState().truckCab)}-images.zip`);
	// 				})
	// 			return Rx.Observable.of("done");
	// 		})
	// 		.subscribe(() => {
	// 			console.log(`created images`);
	// 		});

	// 	let updateOptionsMatrixColors = keyControl$
	// 		.filter(() => process.env.NODE_ENV !== `production`)
	// 		.filter(e => e.keyCode === 68
	// 			&& e.altKey === true
	// 			&& e.metaKey === true
	// 			&& e.ctrlKey === true)
	// 		.switchMap(() => {
	// 			let colorName = prompt("Enter the Color Name");
	// 			let color = prompt("Enter the hex color starting with #");
	// 			return Rx.Observable.of({color, colorName});
	// 		})
	// 		.subscribe(({color, colorName}) => {
	// 			console.log(color);
	// 			store.dispatch({
	// 				type: ACTIONS.HACK_COLORS,
	// 				colorName,
	// 				color
	// 			});
	// 		});

	// }

	let powertrainAndSafetyRotation$ = viewOptionChange$
		.filter(state => state.viewOption === "Powertrain & Safety")
		.switchMap(e => rotateTruck(1, getExteriorBuilder().store.getState(), 315));

	let requestAQuoteRotation$ = activeSummaryChange$
		.switchMap(e => rotateTruck(1, getExteriorBuilder().store.getState(), 315));

	let rotateTruck$ = Rx.Observable.merge(
		rotateTruckDrag$,
		rotateTruckKey$,
		// targetRotation$,
		powertrainAndSafetyRotation$,
		requestAQuoteRotation$
	)
		.map(({showIndex, hideIndex}) => {
			return {
				type: ACTIONS.UPDATE_EXTERIOR_ACTIVE_FRAME,
				data: {
					showIndex,
					hideIndex
				}
			}
		});

	// add event handler to update the exterior view on window resize
	let resizeEvent$ = Rx.Observable.fromEvent(window, "resize")
		.debounceTime(300)
		.map(() => {
			let width = isMobile ? screen.width : window.innerWidth;
			let height = isMobile ? screen.height : window.innerHeight;
			let orientation = isMobile ? window.orientation : 1;
			
			return {
				width,
				height,
				orientation
			}
		})
		.distinctUntilChanged((prevDims, currDims) => {
			return _.isEqual(prevDims, currDims);
		})
		.filter(() => store.getState().view !== "interior")
		.map(() => store.getState());

	let uiResize$ = uiEvent$
		.filter(state => state.actionType === ACTIONS.RESIZE_EXTERIOR);

	let exteriorViewStateUpdate$ = uiEvent$
		.filter(state => state.truckModel !== "" && state.truckCab !== "")
		.map(state => ({
			type: ACTIONS.EXTERIOR_VIEW_STATE_UPDATE,
			data: {
				state
			}
		}));

	let resetViewerDom$ = uiEvent$
		.filter(state => state.truckModel === "" || state.truckCab === "")
		// .do(state => console.log("resetViewerDom$ state update", state))
		.map(state => ({
			type: ACTIONS.RESET_EXTERIOR_VIEW,
			data: {
				state
			}
		}));

	let cabChange$ = uiEvent$
		.filter(state => state.truckCab !== "")
		.distinctUntilChanged((prevState, currState) => {
			return prevState.truckCab === currState.truckCab;
		})
		.map(state => ({
			type: ACTIONS.CAB_CHANGE,
			data: {
				uiState: state
			}
		}));

	// update the exterior view size on window resize and mode change
	let resizeSource$ = Rx.Observable.merge(resizeEvent$, uiResize$)
	// .do(e => console.log("resize source:", e, $container.find(".layers").outerWidth(), $container.find(".layers").outerHeight()))
		.map(() => store.getState())
		.filter(state => {
			return state.cabType !== "" && state.truckCab !== "";
		})
		.map(state => {
			let width = $container.find(".layers").outerWidth();
			let height = $container.find(".layers").outerHeight();
			return {
				width,
				height,
				state
			}
		})
		.distinctUntilChanged((prevDims, currDims) => {
			return _.isEqual(prevDims, currDims);
		})
		.map(({width, height, state}) => {
			return {
				width,
				height
			}
		})
		.distinctUntilChanged((prevDims, currDims) => {
			return _.isEqual(prevDims, currDims)
		})
		.map(({width, height}) => {
			return {
				type: ACTIONS.RESIZE_EXTERIOR,
				data: {
					width,
					height
				}
			};
		});

	// let updateViewer$ = uiEvent$
	// 	.filter(state => state.actionType !== ACTIONS.RESIZE_EXTERIOR)
	// 	.filter(state => {
	// 		return (state.actionType === ACTIONS.EXTERIOR_BUILD_CHANGE
	// 				|| state.actionType === ACTIONS.BUILD_SETTINGS_RESTORE
	// 				|| state.actionType === ACTIONS.CAB_CHANGE)
	// 				&& state.view === "exterior";
	// 	})
	// 	// .do(state => console.log("updateViewer$ state update", state))
	// 	.map(state => ({
	// 		type: ACTIONS.UPDATE_EXTERIOR_VIEW,
	// 		data: {
	// 			state
	// 		}
	// 	}));
	//
	let preCacheOptionLayerImages$ = uiEvent$
		.filter(state => state.actionType === ACTIONS.OPTIONS_IN_VIEW_CHANGE)

		.filter(state => state.view === "exterior" || state.view === "powertrain&safety")
		.filter(state => {
			return _.every(state.optionsInView, "attributes")
		})
		.map(state => ({
			type: ACTIONS.PRECACHE_ACTIVE_OPTION,
			data: state.optionsInView
		}));

	return Rx.Observable.merge(
		//cabChange$,
		exteriorViewStateUpdate$,
		rotateTruck$,
		resizeSource$,
		resetViewerDom$,
		preCacheOptionLayerImages$,
	);
}
